import { AxiosResponse } from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";

export type VersionReviewAlertType = 0 | 1 | 2;

export interface IVersionReviewPayload {
  version: string;
  alertType: VersionReviewAlertType;
  isReview: boolean;
}

export interface IVersionReview {
  version: string;
  alertType: VersionReviewAlertType;
  isReview?: boolean;
}

export const useVersionReview = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: versionReview,
  });
};

export function versionReview(
  body: IVersionReviewPayload
): Promise<AxiosResponse<any>> {
  return httpClient.post(`${ROOT_URL}/api/v1/version-review`, body);
}

export const useGetVersionReview = () => {
  return useQuery<{ data: { data: IVersionReview | IVersionReview[] } }>(
    ["/api/v1/version-review"],
    async () => getVersionReview()
  );
};

export function getVersionReview(): Promise<AxiosResponse<any>> {
  return httpClient.get(`${ROOT_URL}/api/v1/version-review`);
}
